import { SharedModule } from '../../shared/shared.module';
import { SeekersComponent } from './seekers.component';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SeekersListModule } from './seekers_list/seekers-list.module';

@NgModule({
  imports: [NgbModule, SharedModule, SeekersListModule],
  declarations: [SeekersComponent],
  exports: [SeekersComponent]
})
export class SeekersModule {}
